<template>
  <div>
    <v-sheet outlined class="pa-3 my-3">
      <h4 class="blue--text mb-3">حوزه فعالیت </h4>
       
      <v-row>
         <HelperComponent
                helperId="How-to-register-merchant-categories"
                class="mt-1"
              />
        <v-col cols="12" md="6" v-if="merchantCategoriesBreadCrumbList.length">
          <BusinessInformationTable
            :items="merchantCategoriesBreadCrumbList"
            :fields="businessInformationFields"
          />
        </v-col>
        <span v-else class="text--secondary">(وارد نشده)</span>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
import BusinessInformationTable from './BusinessInformationTable.vue';
export default {
  components: {
    BusinessInformationTable,
  },
  props: {
    merchantCategoriesBreadCrumbList: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {
      businessInformationFields: [
        {
          value: 'mainCategoryTitle',
          text: 'نوع فعالیت',
          sortable: false,
        },
        {
          value: 'breadcrumb',
          text: 'فرایند اصلی',
          sortable: false,
        },
      ],
    };
  },
  methods: {},
};
</script>

<style></style>
